import { ReactNode, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { apiClient } from "../lib/apiClient";

interface MeResponse {
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
    status: string;
  };
  is_last_super_admin: boolean;
  csrf_token: string;
}

export function AuthGuard({ children }: { children: ReactNode }) {
  const [state, setState] = useState<"checking" | "ok" | "unauth">("checking");
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get<MeResponse>("/api/admin/auth/me")
      .then((r) => {
        if (cancelled) return;
        apiClient.setCSRF(r.data.csrf_token);
        setState("ok");
      })
      .catch(() => {
        if (!cancelled) setState("unauth");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "checking") {
    return <div style={{ padding: 32 }}>Loading…</div>;
  }
  if (state === "unauth") {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <>{children}</>;
}
